/**
 * @package     Image Hopper
 * @copyright   Copyright (c) 2021, Image Hopper
 * @license     http://opensource.org/licenses/gpl-2.0.php GNU Public License
 */

/**
 * Check if the DOM element is displayed on the current Gravity Forms page
 * @param element
 * @param currentPage {int}
 * @param formId {int}
 * @returns {boolean}
 */
export function fieldOnCurrentPage (element, currentPage, formId) {
  const $currentPageContainer = jQuery(element).parents('.gform_page')
  if (currentPage !== undefined && $currentPageContainer.length > 0 && $currentPageContainer.attr('id') !== 'gform_page_' + formId + '_' + currentPage) {
    return false
  }

  return true
}
